import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DocumentaryProofStatusEnum } from '@app/core/services/data-control-manager/model/enum/documentary-proof-status.enum';
import { ProfileRequestStatusEnum } from '@app/core/services/profile/enum/profile-request-status.enum';
import { ProfileRequest } from '@app/core/services/profile/models/profile-request.model';
import { ProfileType } from '@app/core/services/profile/models/profilte-type.model';
import { ProfileService } from '@app/core/services/profile/profile.service';
import { MobilityAccount } from '@app/core/services/user/models/mobility-account.model';
import { NotificationService } from '@app/core/services/util/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { ManageProfileRequestDialogComponent } from '../manage-profile-request-dialog/manage-profile-request-dialog.component';

@Component({
  selector: 'ap-request-profile-details-content',
  templateUrl: './request-profile-details-content.component.html',
  styleUrls: ['./request-profile-details-content.component.css'],
  standalone: false
})
export class RequestProfileDetailsContentComponent implements OnInit {

  @Input() userView = false;
  @Input() user: MobilityAccount;
  @Input() profileRequest: ProfileRequest;
  @Input() profileTypes: ProfileType[] = [];

  ProfileRequestStatusEnum = ProfileRequestStatusEnum;

  profileRequestForm: UntypedFormGroup;
  editProfileRequestForm = false;
  editValidateButton: boolean = true;

  get reasonStatus() { return this.profileRequestForm.get('reasonStatus').value; }
  get comment() { return this.profileRequestForm.get('comment').value; }

  constructor(private fb: UntypedFormBuilder, private profileService: ProfileService, private dialog: MatDialog, private notificationService: NotificationService, private translateService: TranslateService) {}

  ngOnInit(): void {
    this.initForm();
    if (this.profileRequest.documentaryProofs?.length > 0) {
      this.editValidateButton = !this.profileRequest.documentaryProofs.some(doc => doc.status === DocumentaryProofStatusEnum.REFUSED);
    }
  }

  private initForm(): void {
    this.profileRequestForm = this.fb.group({
      reasonStatus: this.fb.control(this.profileRequest.statusReason),
      comment: this.fb.control(this.profileRequest.comment)
    });
  }

  onSubmitProfileRequest() {
    const newProfileRequest: ProfileRequest = Object.assign({}, this.profileRequest);
    newProfileRequest.statusReason = this.reasonStatus;
    newProfileRequest.comment = this.comment;
    this.profileService.updateProfileRequest(newProfileRequest).subscribe({
      next: updatedProfileRequest => {
        this.profileRequest = updatedProfileRequest
        this.initForm();
        this.editProfileRequestForm = false;
      },
      error: err => this.notificationService.notify('error', this.translateService.instant('PROFILE.PROFILE_REQUEST_DETAIL.COMMON.TOAST.UPDATE.ERROR'))
    });
  }

  resetProfileRequestForm() {
    this.initForm();
    this.editProfileRequestForm = false;
  }

  openDialogTo(validate: boolean) {
    const dialogRef = this.dialog.open(ManageProfileRequestDialogComponent, {
      panelClass: 'modal',
      width: '60%',
      data: {
        profileRequest: this.profileRequest,
        action: validate
      }
    });

    dialogRef.afterClosed().subscribe(dialogData => {
      if (dialogData) {
        const newProfileRequest: ProfileRequest = Object.assign({}, this.profileRequest);
        newProfileRequest.statusReason = dialogData.reasonStatus;
        newProfileRequest.comment = dialogData.comment;
        if (validate) {
          newProfileRequest.beginValidityDate = dialogData.beginDate;
          newProfileRequest.endValidityDate = dialogData.endDate;

          this.profileService.updateProfileRequest(newProfileRequest).subscribe({
            next: updatedProfileRequest => {
              this.profileRequest = updatedProfileRequest;
              this.initForm();
              this.profileService.validateProfileRequest(updatedProfileRequest).subscribe({
                next: validatedProfileRequest => {
                  this.profileRequest = validatedProfileRequest;
                  this.initForm();
                  this.notificationService.notify('success', this.translateService.instant('PROFILE.PROFILE_REQUEST_DETAIL.COMMON.TOAST.VALIDATE.SUCCESS'))
                },
                error: err => this.notificationService.notify('error', this.translateService.instant('PROFILE.PROFILE_REQUEST_DETAIL.COMMON.TOAST.VALIDATE.ERROR'))
              });
            },
            error: err => this.notificationService.notify('error', this.translateService.instant('PROFILE.PROFILE_REQUEST_DETAIL.COMMON.TOAST.UPDATE.ERROR'))
          });
        } else {
          this.profileService.updateProfileRequest(newProfileRequest).subscribe({
            next: updatedProfileRequest => {
              this.profileRequest = updatedProfileRequest;
              this.initForm();
              this.profileService.refuseProfileRequest(newProfileRequest).subscribe({
                next: refusedProfileRequest => {
                  this.profileRequest = refusedProfileRequest;
                  this.initForm();
                  this.notificationService.notify('success', this.translateService.instant('PROFILE.PROFILE_REQUEST_DETAIL.COMMON.TOAST.REFUSE.SUCCESS'))
                },
                error: err => this.notificationService.notify('error', this.translateService.instant('PROFILE.PROFILE_REQUEST_DETAIL.COMMON.TOAST.REFUSE.ERROR'))
              });
            },
            error: err => this.notificationService.notify('error', this.translateService.instant('PROFILE.PROFILE_REQUEST_DETAIL.COMMON.TOAST.UPDATE.ERROR'))
          });
        }
      }
    });
  }

  updateEditValidateButton(value: boolean) {
    this.editValidateButton = value;
  }
}
